import '../SASS/boot.scss';

import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/modal';

import mainNavigation from './modules/main-navigation';
import createSliderHeader from './modules/swiper';
import mailProtect from './modules/mailprotect';
import accordionTabs from './modules/accordion-tabs';
import formFunctions from './modules/form';
import languageSelect from './modules/language-select';

document.addEventListener('DOMContentLoaded', () => {
  mainNavigation();
  mailProtect();
  accordionTabs();
  languageSelect();

  const formSelector = document.querySelector('.js-form');
  if (formSelector !== null) {
    formFunctions(formSelector);
  }

  document.querySelectorAll('.table').forEach((table) => {
    table.classList.add('table-mobile-list');
  });

  // select all slides on the current page
  const allSlidesHeader = document.querySelectorAll('.ba-carousel .swiper-slide');
  if (allSlidesHeader.length > 1) {
    // slider only needs to be created, if there are at least two slides on the page
    document.querySelectorAll('.ba-carousel').forEach((element) => {
      // check how many slides are on the current carousel-element
      if (allSlidesHeader.length > 1) {
        createSliderHeader(element);
      }
    });
    // Swiper play-pause function

    document.querySelectorAll('.ba-carousel').forEach((element) => {
      const initializedSwiper = element.swiper;
      const swiperButtonPausePlay = element.querySelector('.swiper-button-pause-play');
      swiperButtonPausePlay.addEventListener('click', () => {
        if (swiperButtonPausePlay.classList.contains('playing')) {
          initializedSwiper.autoplay.stop();
          swiperButtonPausePlay.classList.remove('playing');
        } else {
          initializedSwiper.autoplay.start();
          swiperButtonPausePlay.classList.add('playing');
        }
      });
    });
  }
});
